import React from "react";
import styles from "./Button.module.scss";
import { useAsyncCallback } from "react-async-hook";
import { twMerge } from "tailwind-merge";
import Loader from "../Loader";
import classNames from "classnames";
export const colors = [
    "main",
    "red",
    "darkRed",
    "orange",
    "darkOrange",
    "purple",
    "darkPurple",
    "gray",
    "darkGray",
    "white",
];
const loaderColors = {
    main: "#0080A8",
    red: "#F55050",
    darkRed: "#c3291c",
    orange: "#d47735",
    darkOrange: "#f18c48",
    purple: "#9044b1",
    darkPurple: "#6D2387",
    gray: "#878787",
    darkGray: "#A1A1A1",
    white: "#fbfbfb",
};
const Button = React.forwardRef(({ className, size = "small", kind = "action", color = "main", children, autoLoading, style = {}, onClick, loading, loader, fillOnHover = false, ariaLabel, ...rest }, ref) => {
    const callback = useAsyncCallback(onClick ?? (() => null));
    const _loading = loading ?? (autoLoading ? callback.loading : undefined);
    let loaderColor;
    if (loader != null) {
        loaderColor = loader.color;
    }
    else {
        loaderColor = kind === "action" ? "#fff" : loaderColors[color];
    }
    return (React.createElement("button", { ref: ref, className: twMerge("ukt-button", styles.button, styles[size], styles[kind], fillOnHover && styles.fillOnHover, styles[color], _loading && styles.loading, className), style: { ...style }, "aria-label": ariaLabel, onClick: !_loading ? callback.execute : undefined, ...rest },
        React.createElement("div", { className: styles.outerWrapper },
            React.createElement("div", { className: styles.contentWrapper }, children),
            _loading && (React.createElement(Loader, { className: classNames("loader"), color: loaderColor })))));
});
export default Button;
//# sourceMappingURL=Button.js.map